import { render, staticRenderFns } from "./user-password.vue?vue&type=template&id=de06de1c&scoped=true"
import script from "./user-password.vue?vue&type=script&lang=js"
export * from "./user-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de06de1c",
  null
  
)

export default component.exports